module.exports = __webpack_public_path__ + "static/media/tv-show-asset1.5bcf2cb6.svg";